<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs :pt-5="$vuetify.breakpoint.lgAndUp">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap justify-center align-center pt-5 pb-10>
            <v-flex xs12 lg10>
              <v-card class="rounded-lg pt-7">
                <!-- <center>
                  <img
                    class="logo-cmp"
                    :src="require('@/assets/img/logoINETCMP.png')"
                    width="400"
                    alt=""
                  />
                </center> -->
                <v-card-text class="black--text" style="font-size: 16px">
                  <v-layout row wrap justify-center align-center pa-1>
                    <v-flex xs12 lg11>
                      <v-card outlined>
                        <v-card-text
                          class="black--text text-center"
                          style="font-size: 16px"
                        >
                          <p>
                            {{ BusinessNameTh }}
                          </p>
                          <p>{{ BusinessNameEng }}</p>
                          <hr style="border-top: 1px solid" />
                          <p class="pb-2 pt-5">
                            <b style="font-size: 22px">ประกาศ </b>
                          </p>
                          <p>{{ AnnounceNo }}</p>
                          <p><b>เรื่อง </b> {{ PolicyHeader }}</p>
                          <hr style="border-top: 1px dashed" />
                          <div class="pt-5" v-html="PolicyDetail"></div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-center
                    pt-4
                    pb-7
                    v-if="NameBtnSave === 'รับทราบ'"
                  >
                    <v-flex xs4 sm4 md2 lg2>
                      <v-btn color="#077893" dark block @click="Fn_Save">
                        {{ NameBtnSave }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-self-center
                    pb-4
                    v-else
                  >
                    <v-flex xs11 sm11 md4 lg4 pt-4>
                      <v-alert border="left" dense text type="success">
                        {{ NameBtnSave }}
                      </v-alert>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { OverlaySearch },
  data: function () {
    return {
      valid: true,
      Consent: [],
      DataConsentStatus: [],
      PolicyDetail: "",
      BusinessNameTh: "",
      AccessToken: "",
      Status: "",
      BusinessName: "",
      ConsentHeader: "",
      SourceSystem: "",
      loadingDownloadData: false,
      DialogGeneral: false,
      NameBtnSave: "รับทราบ",
      Tag: "",
      TypeName: "",
      AccountId: "",
      AnnounceName: "",
      AnnounceNo: "",
      PolicyHeader: "",
    };
  },
  computed: {},
  mounted() {
    this.$cookies.remove("ChatAccountId");
    this.Fn_GetToken();
  },
  methods: {
    async Fn_GetToken() {
      this.loadingDownloadData = true;
      var payload = {
        ShareToken: this.$route.path.split("/")[3],
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/Redirect",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.AccessToken = response.data.Message.AccessToken;
            this.AccountId = response.data.Message.AccountId;
            this.$cookies.set("ChatAccountId", response.data.Message.AccountId);
            this.Fn_getDataAnnounce();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_getDataAnnounce() {
      this.loadingDownloadData = true;
      var payload = {
        AnnounceId: this.$route.path.split("/")[2],
        AccessToken: this.AccessToken,
      };
      var Headers = {
        AccountId: this.$cookies.get("ChatAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/CheckAnnounce",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.getDataConsent = response.data.Message;
            this.BusinessNameTh = response.data.Message.BusinessNameTh;
            this.BusinessNameEng = response.data.Message.BusinessNameEng;
            this.TypeName = response.data.Message.TypeName;
            this.CreatedAt = response.data.Message.CreatedAt;
            this.CreatedAtEng = response.data.Message.CreatedAtEng;
            this.PolicyDetail = response.data.Message.PolicyDetail;
            this.AnnounceName = response.data.Message.AnnounceName;
            this.AnnounceNo = response.data.Message.AnnounceNo;
            this.PolicyHeader = response.data.Message.PolicyHeader;

            this.AnnounceId = response.data.Message.AnnounceId;
            this.Status = response.data.Message.SendStatus;
            if (this.Status === "OK") {
              this.NameBtnSave = "รับทราบประกาศรายการเรียบร้อยแล้ว";
            } else if (this.Status === "WAIT") {
              this.NameBtnSave = "รับทราบ";
            }
          } else {
            window.close();
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          window.close();
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_Save() {
      if (this.$refs.form.validate()) {
        var payload = {
          AccessToken: this.AccessToken,
          AccountId: this.AccountId,
          AnnounceId: this.AnnounceId,
        };
        var Headers = {
          AccountId: this.$cookies.get("ChatAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "onechat/ConfirmAnnounce",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.loadingDownloadData = false;

            if (response.data.Status === "OK") {
              Toast.fire({
                icon: "success",
                title: this.$i18n.t("alert.confirm"),
              });
              this.NameBtnSave = "รับทราบประกาศรายการเรียบร้อยแล้ว";
              this.Fn_getDataAnnounce();
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.loadingDownloadData = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
  },
  watch: {},
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.bg-card {
  background-color: #eeeeee;
}
</style>
